module.exports = __webpack_public_path__ + "604a157aeaafd91f7000571066e277f0.svg";